import { animated, useSpring } from 'react-spring';
import Sticky from 'react-stickynode';

import { Box } from '@hivebrite/design-system/Box';
import { Card } from '@hivebrite/design-system/Card';
import { OrderSummaryCard } from '@hivebrite/design-system/OrderSummary';
import { useBreakpoint } from '@hivebrite/design-system/Theme';

import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import PromoCodeValidation from 'hb-react/shared/apps/Memberships/containers/PromoCode/PromoCodeValidation';
import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';

import MembershipTile from '../MembershipTile';

const STICKY_BREAKPOINTS = {
  xl: true,
  l: true,
  m: false,
  s: false,
};

const DISPLAY_IN_MODAL_BREAKPOINTS = {
  xl: false,
  l: false,
  m: true,
  s: true,
};

const Sidebar = ({
  cartItems,
  topBoundary = '#steps',
  bottomBoundary = '#memberships-v2-app-container',
  memberships = [],
  offset = 0,
  stickyBreakpoints = STICKY_BREAKPOINTS,
  displayInModalBreakpoints = DISPLAY_IN_MODAL_BREAKPOINTS,
  eligibleForPromocodes = false,
}) => {
  const breakpoint = useBreakpoint();
  const { flagEvPaymentsMovePromocode } = useFeatureFlag();
  const { currentUser, currentNetwork } = useDefaultAppContexts();
  const isSticky = stickyBreakpoints[breakpoint] || false;
  const displayInModal = displayInModalBreakpoints[breakpoint] || false;

  return (
    <Sticky
      enabled={isSticky}
      top={topBoundary}
      bottomBoundary={bottomBoundary}
    >
      {({ status }) => (
        <AsideWrapper
          isSticked={status === Sticky.STATUS_FIXED}
          offset={offset}
        >
          {isSticky &&
            memberships.map((membership) => (
              <Box mb={4} key={membership.id}>
                <MembershipTile {...membership} />
              </Box>
            ))}
          <OrderSummaryCard
            cardProps={{
              px: 4,
              py: 6,
              mb: { _: 0, l: 80 },
            }}
            items={cartItems}
            isCompact={displayInModal}
            locale={
              currentUser?.locale || I18n.locale || currentNetwork.locales[0]
            }
          />

          {eligibleForPromocodes && flagEvPaymentsMovePromocode && (
            <Card bg="white" mt={5} p={4}>
              <PromoCodeValidation />
            </Card>
          )}
        </AsideWrapper>
      )}
    </Sticky>
  );
};

const AsideWrapper = ({ children, isSticked = false, offset = 0 }) => {
  const props = useSpring({
    transform:
      isSticked && offset ? `translate(0px, ${offset})` : `translate(0px, 0px)`,
  });

  return <animated.div style={props}>{children}</animated.div>;
};

export default Sidebar;
